import { useLocation } from 'react-router-dom';

export default function useCanonical() {
  const { pathname } = useLocation();
  const canonical = `https://codemeta.de${pathname}`;

  // Remove existing canonical link
  const existing = document.querySelector('link[rel="canonical"]');
  if (existing) {
    document.head.removeChild(existing);
  }

  // Add canonical link to head
  const link = document.createElement('link');
  link.rel = 'canonical';
  link.href = canonical;
  document.head.appendChild(link);

  return () => {
    document.head.removeChild(link);
  };
}
